import { useContext, useState } from "react";
import { Button, Container, Form, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../../context/AuthContext";
import { API } from "../../../../global/global";
import axios from "axios";
import { toast } from "react-toastify";

const PlataformasCrear = () => {
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const [nombre, setNombre] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    
    if (!nombre.trim()) {
      toast.error("El nombre es requerido");
      return;
    }

    setSaving(true);
    
    try {
      await axios.post(
        `${API}/plataforma`,
        { nombre: nombre.trim() },
        {
          headers: {
            Authorization: `Bearer ${authContext.token}`,
          },
        }
      );
      
      toast.success("Plataforma creada correctamente");
      navigate("/main/catalogos/plataformas");
    } catch (error) {
      console.error("Error creating plataforma:", error);
      toast.error("Error al crear la plataforma");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Container>
      <h1>Crear Nueva Plataforma</h1>
      
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Nombre de la Plataforma</Form.Label>
          <Form.Control
            type="text"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            placeholder="Ingrese el nombre de la plataforma"
            required
          />
        </Form.Group>
        
        <div className="d-flex gap-2">
          <Button
            variant="primary"
            type="submit"
            disabled={saving}
          >
            {saving ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Creando...
              </>
            ) : (
              "Crear Plataforma"
            )}
          </Button>
          
          <Button
            variant="secondary"
            onClick={() => navigate("/main/catalogos/plataformas")}
            disabled={saving}
          >
            Cancelar
          </Button>
        </div>
      </Form>
    </Container>
  );
};

export default PlataformasCrear;
